import {
    ArrowForwardIos,
    ContentCopy,
    Delete,
    LinkOff,
    SwapHoriz,
} from "@mui/icons-material";
import React, { memo } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable, id }) => {
    const storageItems = useNodeStorage();

    return (
        <div
            style={{
                backgroundColor: "#ffffff",
                padding: "8px",
                borderRadius: "8px",
                boxShadow: "rgba(0, 0, 0, 0.05) 0px 3px 5px",
                border: "1px solid rgba(59, 130, 246, 0.3)",
            }}
        >
            <Handle
                type="target"
                position="left"
                style={{
                    background: "#2563eb",
                    width: "18px",
                    height: "18px",
                    top: "20px",
                    left: "-12px",
                    cursor: "pointer",
                }}
                onConnect={params => console.log("handle onConnect", params)}
                isConnectable={isConnectable}
            >
                <ArrowForwardIos
                    sx={{
                        color: "#ffff",
                        width: "10px",
                        height: "10px",
                        marginLeft: "2.9px",
                        marginBottom: "1px",
                        pointerEvents: "none",
                    }}
                />
            </Handle>

            <div
                style={{
                    display: "flex",
                    position: "absolute",
                    right: 5,
                    top: 5,
                    cursor: "pointer",
                    gap: 6,
                }}
            >
                <ContentCopy
                    onClick={() => {
                        storageItems.setNodesStorage(id);
                        storageItems.setAct("duplicate");
                    }}
                    sx={{ width: "12px", height: "12px", color: "#2563eb" }}
                />

                <LinkOff
                    onClick={() => {
                        storageItems.setNodesStorage(id);
                        storageItems.setAct("disconnect");
                    }}
                    sx={{ width: "12px", height: "12px", color: "#2563eb" }}
                />

                <Delete
                    onClick={() => {
                        storageItems.setNodesStorage(id);
                        storageItems.setAct("delete");
                    }}
                    sx={{ width: "12px", height: "12px", color: "#2563eb" }}
                />
            </div>

            <div
                style={{
                    color: "#ededed",
                    fontSize: "16px",
                    flexDirection: "row",
                    display: "flex",
                }}
            >
                <SwapHoriz
                    sx={{
                        width: "16px",
                        height: "16px",
                        marginRight: "4px",
                        marginTop: "4px",
                        color: "#2563eb",
                    }}
                />
                <div style={{ color: "#232323", fontSize: "16px" }}>Trocar Conexao</div>
            </div>

            <div style={{ color: "#232323", fontSize: "12px", width: 180 }}>
                <div
                    style={{
                        backgroundColor: "#eff6ff",
                        marginBottom: "3px",
                        borderRadius: "5px",
                        padding: "8px",
                    }}
                >
                    <div
                        style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "10px",
                            textAlign: "center",
                            color: "#1e3a8a",
                        }}
                    >
                        {data?.connection?.name || "Conexao nao selecionada"}
                    </div>
                </div>
            </div>

            <Handle
                type="source"
                position="right"
                id="a"
                style={{
                    background: "#2563eb",
                    width: "18px",
                    height: "18px",
                    top: "70%",
                    right: "-11px",
                    cursor: "pointer",
                }}
                isConnectable={isConnectable}
            >
                <ArrowForwardIos
                    sx={{
                        color: "#ffff",
                        width: "10px",
                        height: "10px",
                        marginLeft: "2.9px",
                        marginBottom: "1px",
                        pointerEvents: "none",
                    }}
                />
            </Handle>
        </div>
    );
});
